import React from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

// Register required Chart.js components
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
);

const DonutChart = ({ data, labels, colors }) => {
    // Calculate total for percentage calculation
    const total = data.reduce((sum, value) => sum + value, 0);
    
    // Chart data
    const chartData = {
        labels: labels,
        datasets: [
            {
                data: data,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 2,
                cutout: '60%', // Makes it a donut chart
            },
        ],
    };

    // Chart options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // We'll use custom legend
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            }
        },
        elements: {
            arc: {
                borderWidth: 0,
            }
        }
    };

    return (
        <div className="donut-chart-container" style={{ position: 'relative', width: '100%', height: '200px' }}>
            <Doughnut data={chartData} options={options} />
            <div className="donut-center-text" style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                fontSize: '14px',
                color: '#666',
                fontWeight: '500'
            }}>
            </div>
        </div>
    );
};

export default DonutChart;
